// @ts-nocheck
/* eslint-disable */
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

export const SET_PRODUCT_NAME = 'SET_PRODUCT_NAME';
export function setProductName(productName) {
  return function (dispatch) {
    dispatch({
      type: SET_PRODUCT_NAME,
      data: {
        productName,
      },
    });
  };
}

export const GetMau = new ReduxAsyncAction('MAU');
GetMau.registerRequest(function () {
  return dash_api.get(`/v1/billing/mau`).then(({ data }) => data);
});
export const MAU = GetMau.constants;

export const GetMonthToDateMau = new ReduxAsyncAction('GET_MONTH_TO_DATE_MAU');
GetMonthToDateMau.registerRequest(function () {
  return dash_api.get(`/v1/billing/month-to-date-mau`).then(({ data }) => data);
});
export const GET_MONTH_TO_DATE_MAU = GetMonthToDateMau.constants;

export const GetExportWhitelist = new ReduxAsyncAction('GET_EXPORT_WHITELIST');
GetExportWhitelist.registerRequest(function () {
  return dash_api.get(`/v1/billing/export_api_whitelist`).then(({ data }) => data);
});
export const GET_EXPORT_WHITELIST = GetExportWhitelist.constants;

export const AddExportWhitelist = new ReduxAsyncAction('ADD_EXPORT_WHITELIST');
AddExportWhitelist.registerRequest(function () {
  return dash_api.post(`/v1/billing/export_api_whitelist`).then(({ data }) => data);
});
export const ADD_EXPORT_WHITELIST = AddExportWhitelist.constants;

export const RemoveExportWhitelist = new ReduxAsyncAction('REMOVE_EXPORT_WHITELIST');
RemoveExportWhitelist.registerRequest(function () {
  return dash_api.delete(`/v1/billing/export_api_whitelist`).then(({ data }) => data);
});
export const REMOVE_EXPORT_WHITELIST = RemoveExportWhitelist.constants;

export const GetSubscriptions = new ReduxAsyncAction('SUBSCRIPTIONS');
GetSubscriptions.registerRequest(function () {
  return dash_api.get(`/v1/billing/product`).then(({ data }) => data);
});
export const SUBSCRIPTIONS = GetSubscriptions.constants;

export const CreateSubscription = new ReduxAsyncAction('CREATE_SUBSCRIPTION');
CreateSubscription.registerRequest(function (sku, tier_id) {
  return dash_api.post('/v1/billing/product', { sku, tier_id }).then(({ data }) => data);
});
export const CREATE_SUBSCRIPTION = CreateSubscription.constants;

// TODO: Remove this once we disable DI1
export const CreateOldSubscription = new ReduxAsyncAction('CREATE_OLD_SUBSCRIPTION');
CreateOldSubscription.registerRequest(function (sku) {
  return dash_api.post('/v1/billing/old-product', { sku }).then(({ data }) => data);
});
export const CREATE_OLD_SUBSCRIPTION = CreateOldSubscription.constants;

export const UpdateSubcriptionTier = new ReduxAsyncAction('UPDATE_SUBSCRIPTION_TIER');
UpdateSubcriptionTier.registerRequest(function (branchMauTier) {
  return dash_api.put('/v1/billing/product/change-tier', { branchMauTier }).then(({ data }) => data);
});
export const UPDATE_SUBSCRIPTION_TIER = UpdateSubcriptionTier.constants;

export const RemoveSubscription = new ReduxAsyncAction('REMOVE_SUBSCRIPTION');
RemoveSubscription.registerRequest(function (sku) {
  return dash_api.put('/v1/billing/product/remove', { sku }).then(({ data }) => data);
});
export const REMOVE_SUBSCRIPTION = RemoveSubscription.constants;

export const GetBillingAccount = new ReduxAsyncAction('BILLING_ACCOUNT');
GetBillingAccount.registerRequest(function () {
  return dash_api.get(`/v1/billing/account`).then(({ data }) => data);
});
export const BILLING_ACCOUNT = GetBillingAccount.constants;

export const GetInvoices = new ReduxAsyncAction('INVOICES');
GetInvoices.registerRequest(function () {
  return dash_api.get(`/v1/billing/invoices`).then(({ data }) => data);
});
export const INVOICES = GetInvoices.constants;

export const GetPayments = new ReduxAsyncAction('PAYMENTS');
GetPayments.registerRequest(function () {
  return dash_api.get(`/v1/billing/payments`).then(({ data }) => data);
});
export const PAYMENTS = GetPayments.constants;

export const GetPaymentMethods = new ReduxAsyncAction('PAYMENT_METHODS');
GetPaymentMethods.registerRequest(function () {
  return dash_api.get(`/v1/billing/payment-methods`).then(({ data }) => data.creditCards);
});
export const PAYMENT_METHODS = GetPaymentMethods.constants;

export const SetPaymentMethodAsDefault = new ReduxAsyncAction('SET_PAYMENT_METHOD_AS_DEFAULT');
SetPaymentMethodAsDefault.registerRequest(function (payment_method_id) {
  return dash_api.put(`/v1/billing/payment-methods/${payment_method_id}/set-default`, {}).then(({ data }) => {
    if (!data.success) {
      throw 'payment method failed';
    }
    return { id: payment_method_id };
  });
});
export const SET_PAYMENT_METHOD_AS_DEFAULT = SetPaymentMethodAsDefault.constants;

export const DeletePaymentMethod = new ReduxAsyncAction('PAYMENT_METHODS_DELETE');
DeletePaymentMethod.registerRequest(function (payment_method_id) {
  return dash_api.delete(`/v1/billing/payment-methods/${payment_method_id}`).then(() => {
    return { id: payment_method_id };
  });
});
export const PAYMENT_METHODS_DELETE = DeletePaymentMethod.constants;

export const DownloadInvoice = new ReduxAsyncAction('DOWNLOAD_INVOICE');
DownloadInvoice.registerRequest(async (filehash) => {
  try {
    const pdf = await dash_api.get(`/v1/billing/invoices/pdf/${filehash}`, {
      responseType: 'blob',
    });
    if (pdf && pdf.data) {
      const blob = new Blob([pdf.data], { type: 'application/pdf' });
      const url = await URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'invoice.pdf';
      link.dispatchEvent(new MouseEvent('click'));
    }
  } catch (err) {
    // do nothing
  }
});
export const DOWNLOAD_INVOICE = DownloadInvoice.constants;

export const SaveBillToContact = new ReduxAsyncAction('SAVE_BILL_TO_CONTACT');
SaveBillToContact.registerRequest(function (billToContact) {
  return Promise.resolve(billToContact);
});
export const SAVE_BILL_TO_CONTACT = SaveBillToContact.constants;

export const GetAccountBalance = new ReduxAsyncAction('GET_ACCOUNT_BALANCE');
GetAccountBalance.registerRequest(function () {
  return dash_api.get(`/v1/billing/balance`).then(({ data }) => data);
});
export const GET_ACCOUNT_BALANCE = GetAccountBalance.constants;
